/*
  CompareCraft（工艺参数对比）by李小萱 2021/5/28
*/
<template>
    <div class="CompareCraft mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/CompareCraft"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-container>
                <el-main>
                    <div class="mainWrao">
                        <div class="recordTitle">
                            <h1>{{$t('leftNav.navTwentySix')}}</h1>
                            <div class="chooseButton">
                                <div style="display:flex">
                                    <el-popover
                                        v-model="visible1"
                                        placement="bottom-start"
                                        @after-leave="hideMachine()"
                                        width="500"
                                        trigger="click"
                                        ref="popover1">
                                        <div class="noMachine" v-if="machineList.length==0">{{$t('EquipmentEfficiency.error5')}}</div>
                                        <div v-else>
                                            <ul class="machineList">
                                                <li @click="selectmachineId(all)" :class="{'active':selectmachine[0].value==''}">{{$t('PartsFaultAlarm.all')}}</li>
                                                <!-- <li v-for="(item,index) in machineList" :class="{'active':selectmachine.includes(item)}" :key="item.value" @click="selectmachineId(item)"  :title="item.label">{{item.label}}</li> -->
                                                <li v-for="item1 in machineList" :class="{'active':isActiveMachine(item1)}" :key="item1.value" @click="selectmachineId(item1)"  :title="item1.label">{{item1.label}}</li>
                                            </ul>
                                            <div style="text-align: right; margin: 0">
                                                <el-button type="primary" size="mini" @click="clickmachine">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                            </div> 
                                        </div>
                                        <el-button type="primary" slot="reference">{{$t('EquipmentEfficiency.chooseEquipment')}}</el-button>                                 
                                    </el-popover>
                                    <div v-loading="loading" style="margin-left:30px;">
                                        <el-popover
                                            v-model="visible2"
                                            placement="bottom-start"
                                            width="300"
                                            @after-leave="hideRecipe"
                                            popper-class="recipePopper"
                                            trigger="click"
                                            ref="popover2">
                                            <div class="noMachine" v-if="noRecord==1">{{$t('EquipmentEfficiency.error3')}}</div>
                                            <div class="noMachine" v-else-if="noRecord==2">{{$t('EquipmentEfficiency.error4')}}</div>
                                            <div v-else>
                                                <el-scrollbar class="machineWrap" style="height:85%;width:100%;">
                                                    <ul class="machineList recipeList">
                                                        <li @click="selectRecipeId(allRecipe)" :class="{'active':selectRecipe[0].value==''}" style="text-align:center;">{{$t('PartsFaultAlarm.all')}}</li>
                                                        <!-- <li v-for="(item,index) in recipeList" :class="{'active':selectRecipe.includes(item)}" :key="item.value" @click="selectRecipeId(item)"  :title="item.label">{{item.label}}</li> -->
                                                        <li v-for="item2 in recipeList" :class="{'active':isActiveRecipe(item2)}" :key="item2.value" @click="selectRecipeId(item2)"  :title="item2.label">{{item2.label}}</li>
                                                    </ul>
                                                </el-scrollbar>
                                                <div style="text-align: right; margin-top: 8px;">
                                                    <el-button type="primary" size="mini" @click="clickrecipe">{{$t('EquipmentEfficiency.button1')}}</el-button>
                                                </div>
                                            </div>
                                            <el-button type="primary" slot="reference" >{{$t('CompareCraft.chooseRecipe')}}</el-button>
                                        </el-popover>
                                    </div>
                                </div>
                                <el-button
                                    icon="el-icon-download"
                                    class="export"
                                    style="margin-left:30px;"
                                    @click="exportExcel()">
                                    {{ $t("ReloadingStatistics.export") }}
                                </el-button>
                                <!-- <el-button type="primary" style="margin-left:50px;" icon="el-icon-view" @click="getTableInfo()">{{$t('StepCycleTime.showBtn')}}</el-button> -->
                            </div>
                        </div>
                        <div class="tableWrap">
                            <!-- 横向tab -->
                            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" class="CompareCraftTable">
                                <!-- 胎体鼓 -->
                                <el-tab-pane v-for="item in navLineGroup" :key="item.order" :label="item.label" :name="item.name">
                                </el-tab-pane>
                            </el-tabs>
                            <!-- 胎体鼓纵向tab -->
                            <div class="verticalWrap">
                                <el-tabs tab-position="left" style="min-height: 300px;" class="navFirst" v-model="columnActive" @tab-click="handleColumnClick">
                                    <el-tab-pane v-for="item in navFirstGroup" :key="item.order" :label="item.label" :name="item.name">
                                    </el-tab-pane>
                                </el-tabs>
                                <!-- 表格 -->
                                <el-table
                                    :data="tableData"
                                    stripe
                                    border
                                    ref="tableList"
                                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                                    fit
                                    style="width: 98%;margin:0 auto;"
                                    @sort-change='sortChange'>
                                    <el-table-column
                                        v-for="(value,key) in tableDataTitle"
                                        :key="key"
                                        :label="value.label"
                                        :prop="value.prop"
                                        align="center"
                                        :min-width="value.minwidth"
                                        :sortable="value.prop=='machine'||value.prop=='styleCode'?'custom':false"
                                        :sort-orders="sortOrders(value.prop)"
                                        >
                                        <template slot-scope="scope">
                                            <el-tooltip effect="dark" placement="bottom" v-if="key!=0 && scope.row[value.prop].value!='-'">
                                                <div slot="content">
                                                    {{ $t("CompareCraft.changePeople") }}:{{scope.row[value.prop].person}}<br/>
                                                    {{ $t("CompareCraft.changeTime") }}:{{scope.row[value.prop].time}}
                                                </div>
                                                <span>{{scope.row[value.prop].value}}</span>
                                            </el-tooltip>
                                            <span v-else>{{scope.row[value.prop].value}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
export default {
    name: 'EquipmentEfficiency',
    components: {
        leftNav
    },
    data(){
        return{
            visible1:false,
            visible2:false,
            //设备选项
            machineList:[],
            //设备上次选中项
            selectBeforeMachine:[{label:"全部",value:''}],
            //设备选中项
            selectmachine:[{label:"全部",value:''}],
            //设备提交项
            choosedmachine:'',
            all:{label:"全部",value:''},
            //规格选项
            recipeList:[],
            //规格上次选中项
            selectBeforeRecipe:[{label:"全部",value:''}],
            //规格选中项
            selectRecipe:[{label:"全部",value:''}],
            //规格提交项
            choosedRecipe:'',
            allRecipe:{label:"全部",value:''},
            noRecord:0, //1是查询范围内无结果，2是未记录
            loading:false,
            //横向tabs选中
            activeName:'1',
            //纵向tabs选中
            columnActive:'',
            //横向tabs内容
            navLineGroup:[],
            //胎体鼓左侧tabs
            navFirstGroup:[],
            //胎体鼓表格数据
            tableData:[],
            //胎体鼓表格循环列
            tableDataTitle:[],
            //获取规格返回的时间，获取表格数据需要
            timeByRecipe:'',
            //loading
            fullscreenLoading:false,
            // 设备排序
            machineSort:null,
            // 配方排序
            styleCodeSort:null
        }
    },
    computed: {
        islangChange () {
            return this.$store.state.lang
        }
    },
    watch: {
        islangChange (curval, oldval) {
            if (curval != oldval) {
                this.$nextTick(()=>{
                    this.$parent.reload()
                })
            }
        },  
    },
    mounted () {
        if (this.$store.state.reloadState === false) {
          this.$store.state.reloadState = true
          this.$parent.reload()
        }else{
            this.fullscreenLoading=true
            this.getmachineList()
            this.getRecipeList()
        }
    },
    methods:{
        //筛选规格框隐藏后
        hideRecipe(){
            let selectRecipes=this.selectRecipe.map(function(obj,index){
                return obj.label;
            }).join(",");
            if(selectRecipes!=this.choosedRecipe)this.selectRecipe=this.selectBeforeRecipe
        },
        //筛选机器框隐藏后
        hideMachine(){
            let selectmachines=this.selectmachine.map(function(obj,index){
                return obj.value;
            }).join(",");
            //若本次选择与选中项(即未确认)不同,恢复到之前选中项
            if(selectmachines!=this.choosedmachine)this.selectmachine=this.selectBeforeMachine
        },
        //machine判断是否选中
        isActiveMachine(chooseOne){
            for(let j=0;j<this.selectmachine.length;j++){
                if(this.selectmachine[j].value==chooseOne.value && this.selectmachine[j].label==chooseOne.label)return true
            }
        },
        //判断recipe是否选中
        isActiveRecipe(chooseOne){
            for(let j=0;j<this.selectRecipe.length;j++){
                if(this.selectRecipe[j].value==chooseOne.value && this.selectRecipe[j].label==chooseOne.label)return true
            } 
        },
        // 获取机械列表
        getmachineList(){
            let _this = this
            this.axios({
                method: 'get',
                url: '/url/parameters/getMachineList',
                params: {
                    isHistory: false,
                }
            }).then(function(res){
                if (res.data.success === true){
                    let machineContent=res.data.data
                    for(let i = 0; i < machineContent.length; i++) {
                        let machineInfo={label:machineContent[i].equipmentName+'('+machineContent[i].nameZh+')',value:machineContent[i].id}
                        _this.machineList.push(machineInfo)
                    }
                }else{
                    _this.$message.error(res.data.msg);
                }
            })  
        },
        // 获取规格列表
        getRecipeList(){
            let _this = this
            this.recipeList=[]
            this.selectRecipe=[{label:"全部",value:''}]
            this.choosedRecipe=''
            this.loading=true
            let recipeData={}
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key5 = "machineIds";
                recipeData[key5] = this.choosedmachine;
            }
            this.axios({
                method: 'get',
                url: '/url/parameters/getCompareStyleCodeList',
                params: recipeData
            }).then(function(res){
                if (res.data.success === true){
                    if('data' in res.data){
                        if(res.data.data.length==0){
                            _this.noRecord=2
                        }else{
                            _this.noRecord=0
                            let recipeContent=res.data.data
                            for(let j = 0; j < recipeContent.length; j++) {
                                let recipeInfo={label:recipeContent[j],value:j+1}
                                _this.recipeList.push(recipeInfo)
                            }
                        }
                        _this.loading=false
                    }else{
                        _this.noRecord=1
                        _this.loading=false
                    }
                    _this.timeByRecipe=res.data.time
                    _this.getLineTabList()
                }else{
                    _this.loading=false
                    // _this.$message.error(res.data.msg);
                }
            })  
        },
        //点击设备
        selectmachineId(item){
            let all = this.selectmachine.some(i=>{
                if(i.label=='全部'||i.label=='All')return true
            })
            let flag = this.selectmachine.some(i=>{
                if(i.value==item.value)return true
            })
            if(flag===true){
                //不直接删除原数组中的项
                let selectmachineList=this.selectmachine.concat([])
                selectmachineList.splice(selectmachineList.indexOf(item), 1)
                this.selectmachine=selectmachineList
                //splice()会改变原本的数组，与push()相似，造成之前选中项随之改变
                // this.selectmachine.splice(selectmachineList.indexOf(item), 1)
                if(this.selectmachine.length===0)this.selectmachine.push(this.all)
                return
            }
            if(item.value===''){
                this.selectmachine=[]
                //concat将两个数组合成一个新的,在进行赋值,selectmachine得到一个新的地址存的新值
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                //采用push的方法会直接改变原数组,会污染原数组
                // this.selectmachine.push(item)
            }else if(all===true){
                this.selectmachine=[]
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                // this.selectmachine.push(item)
            }else{
                let arr = this.selectmachine.concat([item])
                this.selectmachine =arr
                this.selectmachine.sort(this.compare("value"))
                // this.selectmachine=this.selectmachine.push(item)
            }
        },
        //选择设备点击确认
        clickmachine(){
            this.selectBeforeMachine= this.selectmachine
            this.choosedmachine = this.selectmachine.map(function(obj,index){
                return obj.value;
            }).join(",");
            this.getRecipeList()
            this.getTableInfo()
            this.$refs.popover1.doClose()
        },
        //点击规格
        selectRecipeId(item){
            let allRecipe = this.selectRecipe.some(i=>{
                if(i.label=='全部'||i.label=='All')return true
            })
            let flagRecipe = this.selectRecipe.some(i=>{
                if(i.value==item.value)return true
            })
            if(flagRecipe===true){
                let selectRecipeList=this.selectRecipe.concat([])
                selectRecipeList.splice(selectRecipeList.indexOf(item), 1)
                this.selectRecipe=selectRecipeList
                if(this.selectRecipe.length===0)this.selectRecipe.push(this.allRecipe)
                return;
            }
            if(item.value===''){
                this.selectRecipe=[]
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
            }else if(allRecipe===true){
                this.selectRecipe=[]
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
            }else{
                let arr = this.selectRecipe.concat([item])
                this.selectRecipe =arr
                this.selectRecipe.sort(this.compare("value"))
            }
        },
        //选择规格点击确认
        clickrecipe(){
            this.selectBeforeRecipe=this.selectRecipe
            this.choosedRecipe=this.selectRecipe.map(function(obj,index){
                return obj.label;
            }).join(",");
            this.getTableInfo()
            this.$refs.popover2.doClose()
        },
        //切换横向tabs调用
        handleClick(tab) {
            this.getColumnTabList()
            // this.columnActive='0'
        },
        //切换纵向tabs
        handleColumnClick(tab){
            this.getTableInfo()
        },
        //按属性数字大小排序
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        // 获取横向tabs
        getLineTabList(){
            let _this = this
            this.axios({
                method: 'post',
                url: '/url/parameters/getListHeadTitle',
                params: {
                    language:this.$store.state.lang
                }
            }).then(function(res){
                if (res.data.success === 'true'){
                    let lineList=res.data.data
                    // let lineList=res.data.data.reverse()//颠倒顺序
                    lineList.sort(_this.compare("order"))
                    lineList.forEach(element => {
                        element.name=element.name.toString()
                    });
                    _this.navLineGroup=lineList
                    _this.getColumnTabList()
                }else{
                    _this.$message.error(res.data.msg);
                }
            })  
        },
        // 获取对应纵向tabs
        getColumnTabList(){
            let _this = this
            this.axios({
                method: 'post',
                url: '/url/parameters/getListLeftTitle',
                params:{
                    parentId: this.activeName,
                    language:this.$store.state.lang
                }
            }).then(function(res){
                if (res.data.success === 'true'){
                    let columnList=res.data.data
                    // let columnList=res.data.data.reverse()//颠倒顺序
                    columnList.sort(_this.compare("order"))
                    columnList.forEach(element => {
                        element.name=element.name.toString()
                    });
                    _this.columnActive=columnList[0].name
                    _this.navFirstGroup=columnList
                    _this.getTableInfo()
                }else{
                    _this.$message.error(res.data.msg);
                }
            })  
        },
        // 获取表格信息
        getTableInfo(){
            let _this = this
            this.fullscreenLoading=true
            let data={
                parentId: this.columnActive,
                language: this.$store.state.lang,
                time: this.timeByRecipe
            }
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let key3 = "machineIds";
                data[key3] = this.choosedmachine;
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== '' &&this.choosedRecipe !== '全部'){
                let key4 = "recipes";
                data[key4] = this.choosedRecipe;
            }
            if(this.machineSort!==null){
                let key5 = "machineSort";
                data[key5] = this.machineSort;
            }
            if(this.styleCodeSort!==null){
                let key6 = "recipeSort";
                data[key6] = this.styleCodeSort;
            }
            this.axios({
                method: 'post',
                url: '/url/parameters/getCompareListData',
                params: data
            }).then(function(res){
                if (res.data.success === 'true'){
                    let tableNav=res.data.navLineGroup
                    tableNav.forEach(element => {
                        if(element.prop=="machine") element["minwidth"] = '120'
                        else if(element.prop=="styleCode") element["minwidth"] = '220'
                        else element["minwidth"] = '130'
                    });
                    _this.tableDataTitle=tableNav
                    _this.tableData=res.data.tableData
                    console.log(res.data.tableData)
                    _this.fullscreenLoading=false
                }else{
                    _this.$message.error(res.data.msg);
                    _this.fullscreenLoading=false
                }
            })  
        },
        //导出
        exportExcel(){
            let signTime = new Date().getTime()
            this.$store.commit('nowsign', signTime)
            let urlData = '?language='+ this.$store.state.lang + '&time='+ this.timeByRecipe + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime +'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
            if(this.choosedmachine !== null &&this.choosedmachine !== undefined &&this.choosedmachine !== ''){
                let machineIdString = '&machineIds='+ this.choosedmachine
                urlData=urlData+machineIdString
            }
            if(this.choosedRecipe !== null &&this.choosedRecipe !== undefined &&this.choosedRecipe !== '' &&this.choosedRecipe !== '全部'){
                let recipeString = '&recipes='+ this.choosedRecipe
                urlData=urlData+recipeString
            }
            if(this.machineSort!==null){
                let machineSort = '&machineSort='+ this.machineSort
                urlData=urlData+machineSort
            }
            if(this.styleCodeSort!==null){
                let styleCodeSort = '&recipeSort='+ this.styleCodeSort
                urlData=urlData+styleCodeSort
            }
            window.open('/url/parameters/excelCompareListData' + urlData, '_blank')
        },
        // 自定义排序
        sortChange(column){
            this.machineSort=null
            this.styleCodeSort=null
            if (column.prop=='machine'){
                this.machineSort = column.order
            }
            if(column.prop=='styleCode'){
                this.styleCodeSort= column.order
            }
            this.getTableInfo()
        },
        // 排序规则
        sortOrders(name){
            if(name ==='machine'){
                return ['descending','ascending']
            }else if(name==='styleCode'){
                return ['ascending', 'descending']
            }
        }
    }
}
</script>
<style scoped>
.CompareCraft{
  min-width: 1000px!important;
  display: flex;
}
.mainWrao{
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 10px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
  overflow: auto;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
}
.chooseButton{
  margin-top: 10px;
  /* float: right; */
  display: flex;
  justify-content: space-between;
}
.tableWrap{
  box-sizing: border-box;
  margin: 10px 15px;
}
.noMachine{
  text-align: center;
  line-height: 70px;
  color: #909399;
}
.machineList{
  display: flex;
  flex-wrap: wrap;
}
.machineList li{
  width: 150px;
  margin: 0 5px;
  text-align: center;
  height: 24px;
  line-height: 24px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
  border:1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 13px;
  cursor: pointer;
  overflow:hidden;
  padding:0 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing:border-box;
}
.machineList.recipeList li{
  width: 95%;
  text-align: left;
}
.active{
  color:#fff;
  background: #66b1ff;
}
.verticalWrap{
    background-color: #fff;
    display: flex;
    border: 1px solid #DCDFE6;
    box-shadow: 0 5px 5px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
    border-top: none;
}
.CompareCraftTable{
    border-bottom: none;
     box-shadow: 0 -5px 5px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
}
</style>
